module.exports = __webpack_public_path__ + "img/5taskStatus.e483d641.svg";